/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file LicensePage.tsx
 * @desc Created on Tue May 13 2025 18:59:50
 * @copyright All rights reserved @ Inarix
 */

/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file LicencesTable.tsx
 * @desc Created on Mon Apr 28 2025 20:44:52
 * @copyright All rights reserved @ Inarix
 */

import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setTabNameLayout } from "../../redux/slices/layout";
import Layout from "../layout/Layout";
import { useTranslation } from "react-i18next";
import { fetchUsersNewRequest } from "../../redux/actions/users/userAsyncActions";
import {
  fetchAvailPacks,
  fetchLicenses,
} from "../../redux/actions/licenses/licenseListAsyncActions";
import { ThunkDispatch } from "redux-thunk";
import { fetchLocationsWithActivity } from "../../redux/actions/map/mapAsyncActions";
import { BuyLicenseBtn } from "./BuyLicenseBtn";
import { LicencesTable } from "./LicencesTable";
import { LicenseFilterBtns } from "./LicenseFilterBtns";
import { focusedLicense } from "../../redux/slices/licenses/licenseList";
import { useGridApiRef } from "@mui/x-data-grid-pro";

const initData = (dispatch: ThunkDispatch<any, any, any>) => {
  dispatch(fetchUsersNewRequest());
  dispatch(fetchLicenses());
  dispatch(fetchAvailPacks());
  dispatch(fetchLocationsWithActivity());
  dispatch(focusedLicense(""));
  dispatch(setTabNameLayout("/licenses"));
};

export const LicencesPage: FC = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation("global");
  const apiRef = useGridApiRef();
  useEffect(() => {
    initData(dispatch);
  }, []);

  return (
    <Layout
      title={t("licenses.Licenses")}
      component={
        <>
          <BuyLicenseBtn apiRef={apiRef} />
          <LicenseFilterBtns />
          <LicencesTable apiRef={apiRef} />
        </>
      }
    />
  );
};
